import React from 'react';
import {useRsvp} from "../context/RsvpContext";
import {MENSAJE_GENERICO_PLURAL, MENSAJE_GENERICO_SINGULAR} from "../constants/wedding";

// import {LoremIpsum} from "lorem-ipsum";

function AestheticBody() {
    const {rsvp} = useRsvp();

    let message: string;
    let name: string;
    let greeting: string;

    if (!rsvp) {
        message = "Cillum pariatur exercitation deserunt sint excepteur incididunt labore sint enim velit do nisi reprehenderit pariatur cillum. Irure sint cillum cupidatat ea officia irure reprehenderit. Veniam deserunt ad commodo ullamco. Est do non adipisicing ad ad id labore ea veniam mollit. Aliqua labore minim qui ad officia occaecat do irure nulla laborum ut cillum culpa proident ut. Officia tempor officia labore consectetur proident non aliqua id officia consectetur duis. Nisi incididunt minim excepteur.Aute culpa voluptate in ut et ipsum ipsum in Lorem. Elit non excepteur esse est aliqua deserunt cillum laboris aliquip voluptate. Qui et commodo est et consequat quis minim adipisicing fugiat minim aute quis. Voluptate culpa reprehenderit cupidatat. Sint culpa reprehenderit et do sit magna dolore commodo. Fugiat pariatur laboris aliqua ipsum do nulla consequat dolore exercitation ut. Nisi duis voluptate sunt ullamco velit laboris deserunt do culpa laboris anim commodo enim aliqua enim. Do consequat sunt Lorem cupidatat ipsum duis fugiat ullamco nisi sint et aute.";
        name = "Eduardo Serna";
        greeting = "Hola";
    } else {
        message = ""
        message += rsvp?.personalized_messages.both !== '' ? rsvp?.personalized_messages.both + "\n\n" : '';
        message += rsvp?.personalized_messages.Eli !== '' ? rsvp?.personalized_messages.Eli + "\n\n" : '';
        message += rsvp?.personalized_messages.Lalo !== '' ? rsvp?.personalized_messages.Lalo : '';
        name = rsvp?.name;
        greeting = rsvp?.personalized_greeting;
        if (rsvp.code.slice(-1) === 'P'){
            message += "\n\n" + MENSAJE_GENERICO_PLURAL;
        } else {
            message += "\n\n" + MENSAJE_GENERICO_SINGULAR;
        }
    }

    return (
        <div className="aesthetic-body">
            {/* Quote from DB */}
            <div className="mt-16 md:mb-12 aesthetic-column-left bg-white/3 backdrop-blur-sm rounded-3xl">
                <blockquote className="font-autography greetings-text text-left mb-4 mt-4">
                    {greeting} {name},
                </blockquote>
                <blockquote className="font-autography mensaje-both">
                    {message}
                </blockquote>
                <blockquote className="font-autography signature-text text-right mt-8">
                    Eli & Lalo
                </blockquote>
            </div>

            <div className="aesthetic-column-right">
                <img
                    src="images/Foto%20Retrato.png"
                    alt="Aesthetic 1"
                    className="absolute md:-top-20 md:left-0 w-[70%] bottom-[350px] right-10 transform transition-transform duration-300 hover:scale-110 hover:z-50 md:w-[30svw] md:h-[30svw] z-30"
                />
                <img
                    src="images/Fish.jpg"
                    alt="Aesthetic 2"
                    className="absolute bottom-[200px] -left-[20px] md:bottom-[650px] md:left-[500px] w-[55svw] h-[25svh] shadow-xl transform md:rotate-[25deg] rotate-[-25deg] transition-transform duration-300 hover:scale-110 hover:z-50 md:w-[25svw] md:h-[30svh] z-0"
                />
                <img
                    src="images/Muskoka.png"
                    alt="Aesthetic 3"
                    className="absolute -right-[45px] md:-bottom-[80px] md:-right-[175px] w-[60svw] h-[60svh] bottom-0 transform transition-transform duration-300 hover:scale-110 hover:z-50 md:w-[25svw] md:h-[75svh] z-20"
                />
                <img
                    src="images/Foto%20pedida.png"
                    alt="Aesthetic 4"
                    className="absolute md:-bottom-[80px] md:-left-[40px] w-[70%] -left-[50px] bottom-0 transform transition-transform duration-300 hover:scale-110 hover:z-50 md:w-[30svw] md:h-[30svw] z-10"
                />
            </div>
        </div>
    );
}

const AestheticQuotes: React.FC = () => {
    return (
        <section className="overflow-hidden relative md:py-20 pt-20 md:bg-cover bg-contain w-fill"
                 style={{backgroundImage: 'url(images/textura-de-carton.jpg)'}}>
            <div className="container mx-auto px-4 text-center">
                {/* Header Image */}
                <div className="mb-8">
                    <img
                        src="images/Title.png"
                        alt="Header"
                        className="mx-auto md:scale-[60%] md:-mb-48 md:-mt-32 -mb-32 -mt-12"
                    />
                    <img
                        src="images/Oak.png"
                        alt="Aesthetic 4"
                        className="absolute md:-top-[0px] md:-left-[160px] w-40 h-40 transform transition-transform duration-300 hover:scale-110 md:w-[25svw] md:h-[30svw] z-0 left-[-80px] top-[100px]"
                    />
                </div>
                <AestheticBody/>
            </div>
        </section>
    );
};

export default AestheticQuotes;
